import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import { Input, Row, Col, Avatar, Progress } from "antd";
import { useEffect, useState } from "react";
import { Button, Space, Table, Tag } from "antd";
import { v4 as uuid } from "uuid";
import "../../TasksReports.css";

import { db } from "../../../../../../firebase";
import { collection, doc, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
const { Column } = Table;

const WorkFlowRunsTable = () => {
  const [allTask, setAllTask] = useState([]);
  const [userList, setUserList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const filterTasks = (tasks) => {
      return tasks.filter((task) => {
        let matchesSearch =
          !searchTerm ||
          (task.workFlowRunTitle &&
            task.workFlowRunTitle
              .toLowerCase()
              .includes(searchTerm.toLowerCase()));
        return matchesSearch;
      });
    };

    setFilteredTasks(filterTasks(allTask));
  }, [searchTerm, allTask]);

  const fetchUserList = async () => {
    try {
      const userRef = collection(db, "allUsers");

      const querySnapshot = await getDocs(userRef);
      const allItems = querySnapshot.docs.map((doc) => doc.data());
      setUserList(allItems);
    } catch (error) {}
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  const fetchItemList = async () => {
    try {
      const tasksRef = collection(db, "tasks");
      const itemListRef = doc(tasksRef, "itemList");
      const listData = collection(itemListRef, "Assigned");

      const querySnapshot = await getDocs(listData);
      const allItems = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        data.docId = doc.id; // Here we're adding the document ID to the item data
        return data;
      });

      allItems.forEach((workflow) => {
        workflow.workFlowRunAssignee = workflow.workFlowRunAssignee.map(
          (assigneeId) => {
            const user = userList.find((u) => u.uid == assigneeId);
            return user ? user.firstName : assigneeId;
          }
        );
      });

      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      for (let item of allItems) {
        const dateObj = new Date(item.workFlowRunDueDate);
        item.workFlowRunDueDate = `${
          months[dateObj.getMonth()]
        } ${dateObj.getDate()}`;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      setAllTask(allItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userList.length > 0) {
      fetchItemList();
    }
  }, [userList]);

  console.log("allTask", allTask);

  const getInitials = (name) => {
    return name ? name.substring(0, 2) : "";
  };

  const navigate = useNavigate();
  const handleClickItem = (docId) => {
    navigate(`/tasks/inbox/${docId}`);
  };
  return (
    <div className="page-heading">
      <Row gutter={[0, 50]}>
        <Col span={24} style={{ display: "flex" }}>
          <Col
            span={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              name="filterListItems"
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "300px" }}
            />
          </Col>

          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "right",
              justifyContent: "end",
            }}
          >
            <Button style={{ backgroundColor: "#dddddd", fontWeight: "600" }}>
              <DownloadOutlined /> Export
            </Button>
          </Col>
        </Col>

        <Col span={24}>
          <Table
            dataSource={filteredTasks}
            className="custom-table"
            scroll={{
              y: "68vh",
            }}
            pagination={false}
            loading={loading}
          >
            <Column
              title="WORKFLOW"
              dataIndex="workFlowRunName"
              key="workFlowRunName"
              render={(workFlowRunName, record) => (
                <div
                  className="workflow-styling"
                  onClick={() => handleClickItem(record.docId)}
                >
                  {workFlowRunName}
                </div>
              )}
              width={300}
            />
            <Column
              title="NAME"
              dataIndex="workFlowRunTitle"
              key="workFlowRunTitle"
              render={(workFlowRunTitle, record) => (
                <div
                  className="fname-styling"
                  onClick={() => handleClickItem(record.docId)}
                >
                  {workFlowRunTitle}
                </div>
              )}
              width={200}
            />

            <Column
              title="ASSIGNEES"
              dataIndex="workFlowRunAssignee"
              key="workFlowRunAssignee"
              width={110}
              render={(name, record) => (
                <>
                  {name.map((name, index) => (
                    <Avatar key={index}>{getInitials(name)}</Avatar>
                  ))}
                </>
              )}
            />
            {/* <Column
              title="ACTIVITY"
              dataIndex="activity"
              key="activity"
              width={150}
            /> */}
            <Column
              title="TASKS COMPLETED"
              dataIndex="workItemList"
              key="workItemList"
              width={250}
              render={(workItemList, record) => {
                const total = workItemList.length;
                const completed = workItemList.filter(
                  (item) => item.status === "completed"
                ).length;
                const percentage = (completed / total) * 100;

                return (
                  <Progress
                    percent={percentage}
                    format={() => `${completed}/${total}`}
                  />
                );
              }}
            />

            <Column
              title="DUE"
              dataIndex="workFlowRunDueDate"
              key="workFlowRunDueDate"
              width={150}
              render={(date, record) => (
                <>
                  <Space size="middle">{date}</Space>
                </>
              )}
            />

            <Column
              title="OVERDUE TASKSD"
              dataIndex="workItemList"
              key="overdue"
              width={250}
              render={(workItemList, record) => {
                const completed = workItemList.filter(
                  (item) => item.status !== "completed"
                ).length;
                return (
                  <Tag
                    color="error"
                    style={{ minWidth: "50px", textAlign: "center" }}
                  >
                    {completed}
                  </Tag>
                );
              }}
            />
            <Column />
          </Table>
        </Col>
      </Row>
    </div>
  );
};
export default WorkFlowRunsTable;
